import { render } from "./OrganPartsDesktop.vue?vue&type=template&id=5e414192&scoped=true&lang=html"
import script from "./OrganPartsDesktop.vue?vue&type=script&lang=js"
export * from "./OrganPartsDesktop.vue?vue&type=script&lang=js"

import "./OrganPartsDesktop.vue?vue&type=style&index=0&id=5e414192&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e414192"]])

export default __exports__